// extracted by mini-css-extract-plugin
export var statusBar = "s2Tye";
export var statusBarFields = "rDojl";